import ListView from "@/common/custom-lists/ListView";
import { Actions as ADVISOR_ACTIONS } from "@/redux/actions/advisorActions";
import CardContainer from "@/components/common/cards/CardContainer";
import TableViewList from "@/components/common/custom-selectors/TableViewList";
import { useQuery } from "@/components/common/helpers/ReactHooks";
import { orderBy, uniqBy } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import ScheduledPayrollRow from "./ScheduledPayrollRow";

const viewOptions = [
	{
		label: "Normal",
		value: "Normal",
	},
	{
		label: "Card",
		value: "Card",
	},
];

const ScheduledPayrolls = ({ scheduledPayrolls, getScheduledPayrolls, paySchedules, organisations }) => {
	const storedView = localStorage.getItem("advisor-payroll-view");
	const [view, setView] = useState(viewOptions[0]);
	const [company, setCompany] = useQuery("company");
	const columns = useMemo(() => {
		const columns = [];

		switch (view?.value) {
			case "Card":
				columns.push(...["Upcoming Payrolls"]);
				break;
			default:
			case "Normal":
				columns.push(...[{ hidden: true }, "Organisation", "Schedule", "Due", "Status", { hidden: true }]);
				break;
		}
		return columns;
	}, [view?.value]);

	const filteredPayrolls = useMemo(() => {
		return scheduledPayrolls?.filter((p) => (company ? p.org == company : true));
	}, [scheduledPayrolls?.length, company]);

	useEffect(() => {
		if (storedView) setView(viewOptions.find(({ value }) => value == storedView));
	}, [storedView]);

	useEffect(() => {
		getScheduledPayrolls();
	}, []);

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Upcoming Payrolls</h1>
						</div>
					</div>
				</div>
			</div>
			<div className="content bg-white">
				<div className="block-header pr-0 pl-0">
					<div
						className="pull-right"
						style={{ width: 250 }}
					>
						<div className="form-material">
							<Select
								isClearable
								options={organisations}
								styles={{
									menu: (provided) => ({ ...provided, zIndex: 10 }),
								}}
								value={organisations?.find((o) => o.value == company)}
								onChange={(selected) => {
									setCompany(selected?.value || null);
								}}
							/>
							<label>Organisation</label>
						</div>
					</div>
				</div>
				<ListView
					{...{
						title: "Upcoming Payrolls",
						items:
							view?.value !== "Card"
								? filteredPayrolls?.map((period) => (
										<ScheduledPayrollRow
											key={period?.id}
											period={period}
											view={view?.value}
										/>
								  ))
								: null,
						columns,
						viewList: (
							<div className="pull-right">
								<TableViewList
									options={viewOptions}
									value={view}
									onChange={(option) => {
										setView(option);
										localStorage.setItem("advisor-payroll-view", option.value);
									}}
								/>
							</div>
						),
					}}
				/>
				{view?.value === "Card" ? (
					<CardContainer>
						{filteredPayrolls?.map((period) => (
							<ScheduledPayrollRow
								key={period?.id}
								period={period}
								view={view?.value}
							/>
						))}
					</CardContainer>
				) : null}
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const { scheduledPayrolls } = state.advisors || {};

	const organisations = uniqBy(scheduledPayrolls || [], "org")?.map((p) => ({ label: p.companyName, value: p.org }));

	return {
		organisations: orderBy(organisations || [], "label", "asc"),
		scheduledPayrolls: orderBy(scheduledPayrolls || [], "payDay", "asc"),
		isAdmin: state.my.profile.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getScheduledPayrolls: () => dispatch(ADVISOR_ACTIONS.getScheduledPayrolls()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledPayrolls);
